module.exports = __webpack_public_path__ + "static/media/access@3x.3365e719.png";